import React, { useEffect, useState, useRef } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../Components/formElements/InputField";
import { useReactToPrint } from "react-to-print";
import StockQRPrint from "./StockQRPrint";
import QRCodeGenerator from "../common/QRCodeGenerator";

const QrCodePrint = React.forwardRef((props, ref) => {
  const [isCardVisible2, setCardVisible2] = useState(true);
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  // send print data
  const [printStockLabels, setPrintStockLabels] = useState();
  // eslint-disable-next-line
  const [parentInfo, setParentInfo] = useState();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setHeaderData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `Stock Labels${Math.floor(Math.random() * 1000000)}`,
  });
  const [getHeaderData, setHeaderData] = useState({
    numberOfLabels: "",
  });
  //handle cancel modal
  const handleCancel = () => {
    props.onHide();
  };
  useEffect(() => {
    setPrintStockLabels(props.qrInfo);
    setHeaderData(props.qrInfo);
    // eslint-disable-next-line
  }, [props]);

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Qr Code Label - {parentInfo?.stockNr}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">

        {/* Header Details */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">SD</span>
                </Col>
                <Col xs={12} md={2} lg={2}>
                  <span className="headerTitle">Stock Details</span>
                  <span className="subHeaderTitle"> </span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Stock Number"
                      name="stockNr"
                      placeholder=""
                      value={getHeaderData?.stockNr || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Stock Code"
                      name="stockCode"
                      placeholder=""
                      value={getHeaderData?.stockCode || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Product"
                      name="productName"
                      placeholder=""
                      value={getHeaderData?.productName}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Material"
                      placeholder=""
                      name="materialName"
                      id="materialName"
                      value={getHeaderData?.materialName || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Quantity"
                      placeholder=""
                      name="quantity"
                      id="quantity"
                      value={getHeaderData?.quantity || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Stock Desctiption"
                      placeholder=""
                      name="stockDesc"
                      id="stockDesc"
                      value={getHeaderData?.stockDesc || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Stock Group"
                      placeholder=""
                      name="stockGroup"
                      id="stockGroup"
                      value={getHeaderData?.stockGroup || ""}
                      // required={true}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="UOM"
                      placeholder=""
                      name="uOM"
                      id="uOM"
                      value={getHeaderData?.uOM || ""}
                      // required={true}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Batch Number"
                      placeholder=""
                      name="batchNumber"
                      id="batchNumber"
                      value={getHeaderData?.batchNumber || ""}
                      // required={true}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Supplier"
                      placeholder=""
                      name="supplierName"
                      id="supplierName"
                      value={getHeaderData?.supplierName || ""}
                      // required={true}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
                    <InputField
                      className="inputBox"
                      label="Number Of Labels"
                      placeholder=""
                      name="numberOfLabels"
                      id="numberOfLabels"
                      value={getHeaderData?.numberOfLabels || ""}
                      onChange={handleInputChange}
                    />
                  </Col>
                </Row>
                <div className="pt-3 commTopButtonRightLeftPadding">
                  <h5>QR Code</h5>
                  {getHeaderData?.stockCode && getHeaderData?.materialName ? (
                    <QRCodeGenerator
                      value={`Stock Code: ${getHeaderData.stockCode} | Description: ${getHeaderData.materialName}`}
                    />
                  ) : (
                    <p style={{ color: "gray" }}>Stock Code or Material Name missing</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Row className="my-4 ">
          <Col
            lg={{ span: 2, offset: 8 }}
            className="d-flex justify-content-end"
          >
            <button className="btnTable btn-danger" onClick={handleCancel}>
              Cancel
            </button>
          </Col>
          <Col
            lg={2} className="d-flex justify-content-end"
            onClick={handlePrint}
          >
            <button className="btnTable">Print</button>
          </Col>
          <div style={{ display: "none" }}>
            <StockQRPrint ref={contentRef} data={printStockLabels} numberOfLabels={Number(getHeaderData?.numberOfLabels) || 1} />
          </div>
        </Row>
      </Modal.Body>
    </Modal>
  );
});

export default QrCodePrint;
